import { render, staticRenderFns } from "./stock-transfer-details.vue?vue&type=template&id=bd244940&scoped=true"
import script from "./stock-transfer-details.vue?vue&type=script&lang=js"
export * from "./stock-transfer-details.vue?vue&type=script&lang=js"
import style0 from "./stock-transfer-details.vue?vue&type=style&index=0&id=bd244940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd244940",
  null
  
)

export default component.exports